<template>
  <component :is="getExerciseViewName" @next="toNextPage" />
</template>

<script>

export default {
  name: 'Exercise',
  components: {
    KeyboardButtonTest: () => import('@/views/Exercises/KeyboardButtonTest.vue'),
    KeyboardStringTest: () => import('@/views/Exercises/KeyboardStringTest.vue'),
    MouseButtonTest: () => import('@/views/Exercises/MouseButtonTest.vue'),
  },
  computed: {
    getExerciseViewName() {
      return this.$store.getters.getExerciseView;
    },
  },
  methods: {
    toNextPage() {
      this.$store.commit('SET_CURRENT_STEP', 3);
      this.$router.push({ name: this.$store.getters.getStepView });
    },
  },
};
</script>
